$(function () {
    // Masks
    var maskBehavior = function (val) {
            return val.replace(/\D/g, '').length === 11
                ? '(00) 00000-0000'
                : '(00) 0000-00009'
        },
        options = {
            onKeyPress: function (val, e, field, options) {
                field.mask(maskBehavior.apply({}, arguments), options)
            },
        }
    $('.form-tel').mask(maskBehavior, options)
    $('.form-cep').mask('00000-000')
    $('.form-cpf').mask('000.000.000-00')
    $('.form-cnpj').mask('00.000.000/0000-00')
    $('.form-data').mask('00/00/0000')

    // Floating Labels in CF7
    // var formControls = document.querySelectorAll(
    //     '.wpcf7 .form-control, .wpcf7 .form-select'
    // )

    // for (var i = 0; i < formControls.length; i++) {
    //     var input = formControls[i]
    //     var label = input.parentNode.parentNode.querySelector('label')

    //     input.addEventListener('focus', function () {
    //         this.parentNode.parentNode.classList.add('active')
    //     })

    //     input.addEventListener('blur', function () {
    //         var cval = this.value
    //         if (cval.length < 1) {
    //             this.parentNode.parentNode.classList.remove('active')
    //         }
    //     })

    //     if (label) {
    //         label.addEventListener('click', function () {
    //             var input = this.parentNode.querySelector(
    //                 '.form-control, .form-select'
    //             )
    //             input.focus()
    //         })
    //     }
    // }

    // Get container offset
    offsetWidth()
    $(window).on('resize', function () {
        offsetWidth()
    })

    function offsetWidth() {
        var containerOffset = $('.container').offset().left

        // Aplicar padding apenas em desktop (lg breakpoint = 992px)
        // Evitar aplicar quando modos de contraste estão ativos (podem afetar offset)
        if (
            $(window).width() >= 992 &&
            !$('body').hasClass('high-contrast') &&
            !$('body').hasClass('grayscale-contrast')
        ) {
            $('.offcanvas-offset-left').css(
                'padding-left',
                containerOffset + 12
            )
            $('.offcanvas-offset-right').css(
                'padding-right',
                containerOffset + 12
            )
        } else {
            $('.offcanvas-offset-left').css('padding-left', '')
            $('.offcanvas-offset-right').css('padding-right', '')
        }
        $('.container-offset').css('width', containerOffset)
        document.documentElement.style.setProperty(
            '--container-offset',
            containerOffset + 'px'
        )
    }

    // Smooth Scrolling to Anchor Links
    $('.smooth-scroll').bind('click', function (event) {
        var $anchor = $(this)

        $('html, body')
            .stop()
            .animate(
                {
                    scrollTop: $($anchor.attr('href')).offset().top - 300,
                },
                100
            )

        event.preventDefault()
    })

    // Fancybox
    Fancybox.bind()

    // Accessibility Features
    initAccessibilityFeatures()

    // Footer Menu Toggle
    $('.sitemap-nav .menu-item-has-children > a').on('click', function (e) {
        e.preventDefault()

        var $this = $(this)
        var $submenu = $this.siblings('.sub-menu')

        $submenu.toggleClass('show')
        $this.toggleClass('expanded')
    })

    // Offcanvas 3-Column Menu
    initOffcanvasMenu()

    // Mobile Menu
    initMobileMenu()

    // Header Scroll Effect
    initHeaderScrollEffect()
})

function initHeaderScrollEffect() {
    var $header = $('.header')
    var addThreshold = 80 // pixels scrolled before adding class
    var removeThreshold = 30 // pixels scrolled before removing class
    var isScrolled = false

    $(window).on('scroll', function () {
        var scrollTop = $(window).scrollTop()

        // Hysteresis: different thresholds for adding/removing to prevent flickering
        if (!isScrolled && scrollTop > addThreshold) {
            $header.addClass('scrolled')
            isScrolled = true
        } else if (isScrolled && scrollTop < removeThreshold) {
            $header.removeClass('scrolled')
            isScrolled = false
        }
    })
}

function initAccessibilityFeatures() {
    var currentFontSize = 1
    var minFontSize = 0.8
    var maxFontSize = 1.5
    var contrastMode = 0

    function goToContent() {
        var contentTarget = document.getElementById('conteudo')
        if (contentTarget) {
            contentTarget.scrollIntoView({ behavior: 'smooth', block: 'start' })
            contentTarget.setAttribute('tabindex', '-1')
            contentTarget.focus({ preventScroll: true })
        }
    }

    function toggleMenuDrawer() {
        var menuElement = document.getElementById('menuDrawer')
        if (!menuElement) return

        var menuDrawer = bootstrap.Offcanvas.getOrCreateInstance(menuElement)
        var wasOpen = menuElement.classList.contains('show')

        menuDrawer.toggle()

        if (!wasOpen) {
            setTimeout(function () {
                var firstNavLink = document.querySelector('#menuDrawer .nav-link')
                if (firstNavLink) {
                    firstNavLink.focus()
                }
            }, 300)
        }
    }

    function focusSearch() {
        var searchInput = document.querySelector('#busca input[type="search"]')
        if (searchInput) {
            searchInput.focus()
        }
    }

    $(document).on('click', '[data-key="1"]', function (e) {
        e.preventDefault()
        goToContent()
    })

    $(document).on('click', '[data-key="2"]', function (e) {
        e.preventDefault()
        toggleMenuDrawer()
    })

    $(document).on('click', '[data-key="3"]', function (e) {
        e.preventDefault()
        focusSearch()
    })

    // Keyboard navigation for accessibility links (Alt + 1, Alt + 2, Alt + 3)
    $(document).on('keydown', function (e) {
        // Alt + shortcuts
        if (e.altKey) {
            // Usar keyCode como fallback para melhor compatibilidade
            var key = e.key || String.fromCharCode(e.keyCode)

            // keyCode: 49 = 1, 50 = 2, 51 = 3
            if (e.keyCode === 49 || key === '1') {
                e.preventDefault()
                goToContent()
            } else if (e.keyCode === 50 || key === '2') {
                e.preventDefault()
                toggleMenuDrawer()
            } else if (e.keyCode === 51 || key === '3') {
                e.preventDefault()
                focusSearch()
            } else if (key === '+' || key === '=' || e.keyCode === 187 || e.keyCode === 107) {
                e.preventDefault()
                zoomIn()
            } else if (key === '-' || e.keyCode === 189 || e.keyCode === 109) {
                e.preventDefault()
                zoomOut()
            } else if (key === 'c' || key === 'C' || e.keyCode === 67) {
                e.preventDefault()
                toggleContrast()
            }
        }
    })

    // Zoom In functionality
    function zoomIn() {
        if (currentFontSize < maxFontSize) {
            currentFontSize += 0.1
            $('html').css('font-size', currentFontSize + 'rem')
            localStorage.setItem('fontSize', currentFontSize)
        }
    }

    // Zoom Out functionality
    function zoomOut() {
        if (currentFontSize > minFontSize) {
            currentFontSize -= 0.1
            $('html').css('font-size', currentFontSize + 'rem')
            localStorage.setItem('fontSize', currentFontSize)
        }
    }

    // Toggle Contrast functionality (3 estados: normal, invertido, preto e branco)
    var contrastMode = 0 // 0 = normal, 1 = invertido, 2 = preto e branco

    function toggleContrast() {
        // Remover classes existentes
        $('body').removeClass('high-contrast grayscale-contrast')

        // Avançar para o próximo modo
        contrastMode = (contrastMode + 1) % 3

        // Aplicar classe baseada no modo
        switch (contrastMode) {
            case 1:
                $('body').addClass('high-contrast')
                break
            case 2:
                $('body').addClass('grayscale-contrast')
                break
            default:
                // Modo 0 (normal) - sem classes
                break
        }

        // Salvar no localStorage
        localStorage.setItem('contrastMode', contrastMode)

        // Recalcular offset após mudança de modo
        setTimeout(function () {
            offsetWidth()
        }, 50)
    }

    // Button event listeners
    $('#zoom-in').on('click', zoomIn)
    $('#zoom-out').on('click', zoomOut)
    $('#toggle-contrast').on('click', toggleContrast)

    // Load saved preferences
    var savedFontSize = localStorage.getItem('fontSize')
    var savedContrastMode = localStorage.getItem('contrastMode')

    if (savedFontSize) {
        currentFontSize = parseFloat(savedFontSize)
        $('html').css('font-size', currentFontSize + 'rem')
    }

    if (savedContrastMode) {
        contrastMode = parseInt(savedContrastMode)
        switch (contrastMode) {
            case 1:
                $('body').addClass('high-contrast')
                break
            case 2:
                $('body').addClass('grayscale-contrast')
                break
            default:
                contrastMode = 0
                break
        }
    }
}

function initOffcanvasMenu() {
    var $container = $('.offcanvas-menu-container')

    $('.menu-level-1 .menu-item-has-children').on('mouseenter', function () {
        var $this = $(this)
        var menuId = $this.data('menu-id')

        $container.removeClass('show-level-2 show-level-3 show-level-4')
        $('.menu-level-1 .nav-item, .menu-level-2 .nav-item, .menu-level-3 .nav-item').removeClass('active')
        $('.menu-level-2-group, .menu-level-3-group, .menu-level-4-group').removeClass('active')

        $this.addClass('active')

        $('.menu-level-2-group[data-parent="' + menuId + '"]').addClass('active')
        $container.addClass('show-level-2')
    })

    $('.menu-level-1 .nav-item:not(.menu-item-has-children)').on('mouseenter', function () {
        $container.removeClass('show-level-2 show-level-3 show-level-4')
        $('.menu-level-1 .nav-item, .menu-level-2 .nav-item, .menu-level-3 .nav-item').removeClass('active')
        $('.menu-level-2-group, .menu-level-3-group, .menu-level-4-group').removeClass('active')

        $(this).addClass('active')
    })

    $(document).on('mouseenter', '.menu-level-2 .menu-item-has-children', function () {
        var $this = $(this)
        var menuId = $this.data('menu-id')

        $container.removeClass('show-level-4')
        $('.menu-level-2 .nav-item, .menu-level-3 .nav-item').removeClass('active')
        $('.menu-level-3-group, .menu-level-4-group').removeClass('active')

        $this.addClass('active')

        $('.menu-level-3-group[data-parent="' + menuId + '"]').addClass('active')
        $container.addClass('show-level-3')
    })

    $(document).on('mouseenter', '.menu-level-3 .menu-item-has-children', function () {
        var $this = $(this)
        var menuId = $this.data('menu-id')

        $('.menu-level-3 .nav-item').removeClass('active')
        $('.menu-level-4-group').removeClass('active')

        $this.addClass('active')

        $('.menu-level-4-group[data-parent="' + menuId + '"]').addClass('active')
        $container.addClass('show-level-4')
    })

    $('.menu-level-1').on('mouseleave', function () {
        setTimeout(function () {
            if (!$('.menu-level-2:hover, .menu-level-3:hover, .menu-level-4:hover').length) {
                $container.removeClass('show-level-2 show-level-3 show-level-4')
                $('.menu-level-1 .nav-item, .menu-level-2 .nav-item, .menu-level-3 .nav-item').removeClass('active')
                $('.menu-level-2-group, .menu-level-3-group, .menu-level-4-group').removeClass('active')
            }
        }, 100)
    })

    $('.menu-level-2').on('mouseleave', function () {
        setTimeout(function () {
            if (!$('.menu-level-3:hover, .menu-level-4:hover').length) {
                $container.removeClass('show-level-3 show-level-4')
                $('.menu-level-2 .nav-item, .menu-level-3 .nav-item').removeClass('active')
                $('.menu-level-3-group, .menu-level-4-group').removeClass('active')
            }
        }, 100)
    })

    $('.menu-level-3').on('mouseleave', function () {
        setTimeout(function () {
            if (!$('.menu-level-4:hover').length) {
                $container.removeClass('show-level-4')
                $('.menu-level-3 .nav-item').removeClass('active')
                $('.menu-level-4-group').removeClass('active')
            }
        }, 100)
    })

    $('.offcanvas-menu-container').on('mouseleave', function () {
        setTimeout(function () {
            $container.removeClass('show-level-2 show-level-3 show-level-4')
            $('.menu-level-1 .nav-item, .menu-level-2 .nav-item, .menu-level-3 .nav-item').removeClass('active')
            $('.menu-level-2-group, .menu-level-3-group, .menu-level-4-group').removeClass('active')
        }, 150)
    })

    $('.menu-level-2').on('mouseenter', function () {
        $container.addClass('show-level-2')
    })

    $('.menu-level-3').on('mouseenter', function () {
        $container.addClass('show-level-3')
    })

    $('.menu-level-4').on('mouseenter', function () {
        $container.addClass('show-level-4')
    })

    $(document).on('mouseenter', '.menu-level-2 .nav-item:not(.menu-item-has-children)', function () {
        $('.menu-level-2 .nav-item').removeClass('active')
        $(this).addClass('active')
        $container.removeClass('show-level-3 show-level-4')
        $('.menu-level-3-group, .menu-level-4-group').removeClass('active')
    })

    $(document).on('mouseenter', '.menu-level-3 .nav-item:not(.menu-item-has-children)', function () {
        $('.menu-level-3 .nav-item').removeClass('active')
        $(this).addClass('active')
        $container.removeClass('show-level-4')
        $('.menu-level-4-group').removeClass('active')
    })
}

function initMobileMenu() {
    // Click em botão de navegação (items com filhos)
    $(document).on('click', '.mobile-nav-btn', function (e) {
        e.preventDefault()

        var targetId = $(this).data('target')
        var $targetLevel = $('#' + targetId)
        var $currentLevel = $(this).closest('.mobile-menu-level')

        // Esconder nível atual
        $currentLevel.removeClass('active').addClass('hide')

        // Mostrar nível alvo
        $targetLevel.removeClass('hide').addClass('active')
    })

    // Click em botão voltar
    $(document).on('click', '.mobile-back-btn', function (e) {
        e.preventDefault()

        var target = $(this).data('target')
        var $currentLevel = $(this).closest('.mobile-menu-level')

        // Esconder nível atual
        $currentLevel.removeClass('active').addClass('hide')

        if (target === '1' || target === 1) {
            // Voltar para nível 1
            var $level1 = $('.mobile-menu-level[data-level="1"]')

            // Garantir que todos os outros níveis estejam escondidos
            $('.mobile-menu-level')
                .not($level1)
                .removeClass('active')
                .addClass('hide')

            // Mostrar nível 1
            $level1.removeClass('hide').addClass('active')
        } else {
            // Voltar para nível específico
            var $targetLevel = $('#' + target)
            $targetLevel.removeClass('hide').addClass('active')
        }
    })

    // Funções globais para calendários
    window.calendarHandlers = {
        // Adicionar ao Apple/Outlook - simplesmente abre a URL
        // O servidor retorna o arquivo .ics com Content-Type correto
        addToCalendar: function(icsUrl) {
            window.location.href = icsUrl;
        }
    };
}
